import React from 'react';
import { Box, Stack, Typography, useTheme } from '@mui/material';

interface StatusTagProps {
  status: 'REJECTED' | 'IN_PROGRESS' | 'COMPLETED' | 'PENDING';
}

/**
 * A component that displays a status tag with a given status
 * @param {{status: 'REJECTED' | 'IN_PROGRESS' | 'COMPLETED' | 'PENDING'}} props
 * @returns {JSX.Element}
 */
const StatusTextCircle: React.FC<StatusTagProps> = ({ status }) => {
  const theme = useTheme();

  const getStatusColor = (status: string) => {
    switch (status) {
      case 'REJECTED':
        return '#FF6F78';
      case 'IN_PROGRESS':
        return '#FFD80D';
      case 'COMPLETED':
        return '#7EBB00';
      case 'PENDING':
        return '#A0A0A0';
      default:
        return theme.palette.grey[500];
    }
  };

  const getStatusText = (status: string) => {
    switch (status) {
      case 'REJECTED':
        return 'כישלון';
      case 'IN_PROGRESS':
        return 'בתהליך';
      case 'COMPLETED':
        return 'נקלט בהצלחה';
      case 'PENDING':
        return 'ממתין';
      default:
        return 'סטטוס לא ידוע';
    }
  };

  return (
    <Stack direction="row" gap={0.7} alignItems="center">
      <Box
        sx={{
          width: '13px',
          height: '13px',
          borderRadius: '50%',
          backgroundColor: getStatusColor(status),
        }}
      />
      <Typography fontWeight={'700'} fontSize={'14px'} fontFamily={'AlmoniDL'}>
        {getStatusText(status)}
      </Typography>
    </Stack>
  );
};

export default StatusTextCircle;
